import styled from 'styled-components'
import { Alert, Icon, Steps } from 'antd'

const ContainerSteps = styled.div`
  align-items: center;
  background-color: white;
  display: flex;
  justify-content: center;
  margin-top: 12px;
  padding: 12px 16px;
`

const WrapAlert = styled(Alert)`
  margin: 12px 24px 0 24px;
`

const WrapSteps = styled(Steps)`
  flex: 1;
  height: 32px;
  margin: 0 24px;
  width: auto;

  .ant-steps-item-finish {
    .ant-steps-item-title::after {
      background-color: rgba(241, 90, 48, 1) !important;
    }
  }
`

const WrapStepsIcon = styled.span<{ status: string }>`
  color: ${({ status }) =>
    status === 'wait' ? 'rgba(150, 150, 150, 1)' : 'rgba(241, 90, 48, 1)'};
  font-size: 28px;
  font-weight: 600;
  height: 31px;
  line-height: 28px;
  margin-right: 0.5rem;
`
const WrapStepsIconCheck = styled(Icon)`
  color: rgba(241, 90, 48, 1);
  height: 28px;
  margin-right: 0.5rem;
  width: 28px;
`

const WrapStepsTitle = styled.span<{ status: string }>`
  align-items: center;
  color: ${({ status }) =>
    status === 'wait' ? 'rgba(150, 150, 150, 1)' : 'rgba(241, 90, 48, 1)'};
  cursor: default;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`

export {
  ContainerSteps,
  WrapAlert,
  WrapSteps,
  WrapStepsIcon,
  WrapStepsIconCheck,
  WrapStepsTitle
}
